module.exports = __webpack_public_path__ + "static/perfectsignage-cf33293fed9ba96036a9c4a263b2445b.jpg";